export type OfferState = {
  selected_offer: string;
  coupon_code: string;
  mensual_price: string;
  highlighted?: boolean;
  reference_devis: string;
  type_promotion: string;
};

export const initialOfferState: OfferState = {
  selected_offer: '',
  coupon_code: '',
  mensual_price: '',
  highlighted: false,
  reference_devis: '',
  type_promotion: ''
};
